import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TagService = {
  getList: async () => {
    const response = await apiService.get("/tags");
    console.log(response);
    return response.data;
  },

   create: async (data) => {
    const response = await apiService.post("/tags",data);
    return response.data;
  },

  update: async (id,updatedData) => {
    const response = await apiService.put(`/tags/${id}`,updatedData);
    return response.data;
  },

  getbyId: async (id) => {
    
    
    const response = await apiService.get(`/tags/${id}`);
    console.log("called",response);
    console.log("called",response.data);
    return response.data;
    
  }, 
  delete: async (id) => {
    console.log(id)
    const response = await apiService.delete(`/tags/${id}`);
    console.log("called",response)
    return response.data;
  }

};
export default TagService;
